var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTtmsLogo = function SvgTtmsLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.477 23.477",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.477,
    height: 23.477,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TTMS",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(12.498 3.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M81.486,26.862H79.31V25.1h6.362v1.762H83.5v5.492h-2.01Z",
    transform: "translate(-79.31 -25.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(4.227 12.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M26.88,81.55H29l1.73,2.808,1.73-2.808h2.124V88.8h-2V84.638l-1.854,2.839h-.042l-1.845-2.818V88.8H26.88Z",
    transform: "translate(-26.88 -81.55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(4.557 3.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M31.1,26.862H28.92V25.1h6.362v1.762H33.108v5.492H31.1Z",
    transform: "translate(-28.92 -25.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M23.477,23.477H0V0H23.477ZM1.357,22.159H22.122V1.319H1.357Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M91.332,83.742l-.944-.3-.034-.01c-.116-.034-.521-.146-.558-.433a.387.387,0,0,1,.338-.49,22.036,22.036,0,0,1,2.207.144l.333.042.251-1.678-.333-.04a22.816,22.816,0,0,0-2.564-.16l-.131.01A2.214,2.214,0,0,0,87.93,83,2.527,2.527,0,0,0,89.8,85.4l.936.3.082.023c.107.027.574.081.525.522a.4.4,0,0,1-.367.393c-.325,0-1.4-.023-2.466-.146l-.335-.039-.231,1.68.335.039a27.5,27.5,0,0,0,2.773.158h.05l.05,0a2.253,2.253,0,0,0,2.057-2.254A2.4,2.4,0,0,0,91.332,83.742Z",
    transform: "translate(-74.053 -68.62)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTtmsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ttms_logo.686fd39a.svg";
export { ForwardRef as ReactComponent };